var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"text-center"},[_c('h2',{staticClass:"display-2 d-inline-block"},[_vm._v("Seite nicht gefunden")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }